var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"whatsapp-button",attrs:{"href":("http://api.whatsapp.com/send?1=pt_BR&phone=" + _vm.phone),"target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/images/logos/whatsapp.png"),"alt":"whatsapp"}})])}
var staticRenderFns = []

export { render, staticRenderFns }